module.exports = __webpack_public_path__ + "img/pagebg.009df798.png";